import { gql } from "@grandvisionhq/graphql";
const StoreReservabilityFragment = gql`
  fragment StoreReservability on Store {
    productReservability {
      inStoreReservable
    }
  }
`;
export {
  StoreReservabilityFragment as default
};
//# sourceMappingURL=store-reservability.js.map
